import { render, staticRenderFns } from "./kingKong.vue?vue&type=template&id=0a485ef9&scoped=true&"
import script from "./kingKong.vue?vue&type=script&lang=js&"
export * from "./kingKong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a485ef9",
  null
  
)

export default component.exports